<script>
	import Router from "svelte-spa-router";
	import Login from "./paginas/login.svelte";
	import Home from "./paginas/home.svelte";
	import NuevoCliente from "./paginas/nuevoCliente.svelte";
	import NuevaMascota from "./paginas/nuevaMascota.svelte";
	import Cliente from "./paginas/cliente.svelte";
	import Mascota from "./paginas/mascota.svelte";
	import Historia from "./paginas/historia.svelte";
	import Vacuna from "./paginas/vacuna.svelte";
	import Info from "./paginas/info.svelte";
	let routes = {
		"/":Login,
		"/info":Info,
		"/home":Home,
		"/agregar/cliente":NuevoCliente,
		"/agregar/mascota/":NuevaMascota,
		"/agregar/mascota/:cliente":NuevaMascota,
		"/cliente/:documento":Cliente,
		"/mascota/:documento":Mascota,
		"/mascota/:documento/historia":Historia,
		"/mascota/:documento/vacuna":Vacuna
	}
</script>

<Router {routes} />
